import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register('/build/sw.js', {
    ready() {
      // console.log('App is ready to work offline.')
    },
    registered() {
      // console.log('Service worker has been registered.')
    },
    cached() {
      // Content has been cached
    },
    updatefound(registration) {
      window.swRegistration = registration;
      window.dispatchEvent(new CustomEvent('sw-update-downloading'));
    },
    updated(registration) {
      window.swRegistration = registration;
      window.dispatchEvent(new CustomEvent('sw-update-waiting'));
    },
    offline() {
      // App is running in offline mode
    },
    error(error) {
      window.dispatchEvent(new CustomEvent('sw-update-error', { detail: error }));
    }
  })
}
